function Greenland({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1257)">
        <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16C31.3044 16 16 18.0869 16 18.0869L0 16Z" fill="#F0F0F0"/>
        <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="#D80027"/>
        <path d="M11.1305 23.6523C15.3566 23.6523 18.7826 20.2263 18.7826 16.0001C18.7826 11.7739 15.3566 8.3479 11.1305 8.3479C6.90427 8.3479 3.47827 11.7739 3.47827 16.0001C3.47827 20.2263 6.90427 23.6523 11.1305 23.6523Z" fill="#F0F0F0"/>
        <path d="M3.47827 16.0001C3.47827 11.774 6.90427 8.3479 11.1305 8.3479C15.3567 8.3479 18.7826 11.774 18.7826 16.0001" fill="#D80027"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Greenland;
